module.exports = __webpack_public_path__ + "static/media/gallery.84737484.jpg";